import { dew as _stringsDew } from "../../constants/strings.js";
import { dew as _concatDew } from "../data/concat.js";
import { dew as _toBytesDew } from "../encoding/toBytes.js";
import { dew as _keccakDew } from "../hash/keccak256.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.hashMessage = void 0;
  const strings_js_1 = _stringsDew();
  const concat_js_1 = _concatDew();
  const toBytes_js_1 = _toBytesDew();
  const keccak256_js_1 = _keccakDew();
  function hashMessage(message, to_) {
    const messageBytes = (() => {
      if (typeof message === "string") return (0, toBytes_js_1.stringToBytes)(message);
      if (message.raw instanceof Uint8Array) return message.raw;
      return (0, toBytes_js_1.toBytes)(message.raw);
    })();
    const prefixBytes = (0, toBytes_js_1.stringToBytes)(`${strings_js_1.presignMessagePrefix}${messageBytes.length}`);
    return (0, keccak256_js_1.keccak256)((0, concat_js_1.concat)([prefixBytes, messageBytes]), to_);
  }
  exports.hashMessage = hashMessage;
  //# sourceMappingURL=hashMessage.js.map
  return exports;
}